<template>
<div class="chapter">
<div class="inner_page">
<p class="copy" style="margin-top: 3em;">Text copyright © 2014 by Lisa Doan<br/>Illustrations copyright © 2014 by Lerner Publishing Group, Inc.</p>
<p class="copy">All rights reserved. International copyright secured. No part of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopying, recording, or otherwise—without the prior written permission of Lerner Publishing Group, Inc., except for the inclusion of brief quotations in an acknowledged review.</p>
<p class="copy">Darby Creek<br/>A division of Lerner Publishing Group, Inc.<br/>241 First Avenue North<br/>Minneapolis, MN 55401 USA</p>
<p class="copy">For reading levels and more information, look up this title at <a href="http://www.lernerbooks.com" target="_blank">www.lernerbooks.com</a>.</p>
<p class="copy">Cover and interior images © iStockphoto.com/subjug (mail envelope); © Christian Mueringer/Dreamstime.com (vintage postage stamp); © iStockphoto.com/blondiegirl (postage meter); © ilolab/Shutterstock.com (wood background); © Picsfive/Shutterstock.com (note paper); © CWB/Shutterstock.com (passport stamps); © Tsyhun/Shutterstock.com (canvas passport background).</p>
<p class="copy">Main body text set in Janson Text LT Std 12/17.5.<br/>Typeface provided by Linotype AG.</p>
<p class="copy2">Library of Congress Cataloging-in-Publication Data</p>
<p class="copy1">Doan, Lisa.</p>
<p class="copy3">Jack and the wild life / by Lisa Doan ; illustrated by Ivica Stevanovic.<br/>      pages cm. —(The Berenson schemes ; #2)</p>
<p class="copy4">Summary: Jack’s parents have decided to guide safaris in Africa, much to Jack’s chagrin, and none of their previous schemes have worked.</p>
<p class="copy3">ISBN 978–1–4677–1077–0 (trade hard cover : alk. paper)<br/>ISBN 978–1–4677–4643–4 (eBook)</p>
<p class="copy4">[1. Adventure and adventurers—Fiction.  2. Safaris—Fiction.  3. Parents—Fiction.  4. Eccentrics and eccentricities—Fiction.  5. Africa—Fiction.  6. Humorous stories.]  I. Title.<br/>PZ7.D6485Jab 2014<br/>[Fic]—dc23</p>
<p class="copy4" style="text-align: right;">2013023167</p>
<p class="copy1">Manufactured in the United States of America<br/>1 – SB – 7/15/14<br/>eISBN: 978-1-4677-4643-4 (pdf)<br/>eISBN: 978-1-4677-7399-7 (ePub)<br/>eISBN: 978-1-4677-7398-0 (mobi)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copy.vue?4ce649c0